module.exports = __webpack_public_path__ + "img/menu-icon-tnc.4e6fcb37.svg";